import React from 'react';
import styled from 'styled-components';
import color, { fox } from 'styles/colors';
import { respondTo } from 'styles/helper';
import { fadein } from 'styles/animations';
import Image from 'components/common/Image';
import Link from 'components/common/Link';

export type Props = {
  provider: string;
  url: string;
  link?: string;
  handleMVPDSelect?: () => void;
};

const ProviderButton = ({ provider, url, handleMVPDSelect, link = '' }: Props): JSX.Element => {
  const parser = document.createElement('a');
  parser.href = url;
  return (
    <Button onClick={handleMVPDSelect}>
      <Link passHref href={link}>
        <ImageContainer>
          <Image
            src={url}
            alt={provider}
            width={85}
            height={30}
            quality={65}
            className="image"
            priority
          />
        </ImageContainer>
      </Link>
    </Button>
  );
};

export default ProviderButton;

const Button = styled.button`
  position: relative;
  display: flex;
  width: 100%;
  height: 80px;
  max-height: 80px;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  transition: all ease 300ms;
  cursor: pointer;
  ${respondTo.bp_767`
    height: 100px;
    max-height: 100px;
  `}
  img {
    width: 100%;
    max-width: calc((100vw - 10px - 60px) / 4);
    ${respondTo.bp_767`
      max-width: calc(100% - 85px);
    `}
  }
  &:hover {
    transform: scale(1.05);
    transition: all ease 300ms;
  }
  &:not(:hover):not(:active) {
    border: 1px solid ${fox.white10};
    background: ${fox.white05};
    border-radius: 3px;
  }
  &:hover:not(.inactive),
  &:active:not(.inactive) {
    background-color: ${color.white};
    color: ${color.black};
    border: none;
    img {
      filter: grayscale(1) invert(1);
    }
  }
`;

const ImageContainer = styled.div`
  ${fadein};
  img {
    object-fit: contain;
  }
`;
